import './bootstrap';
import './analytics';
import './webmcp';
import 'bootstrap';
import { createApp, h } from 'vue';
import ChatWidget from './components/ChatWidget.vue';

// Press "/" anywhere (outside a text field) to focus the search field.
document.addEventListener('keydown', (event) => {
    const target = event.target;
    const isTyping = target instanceof HTMLElement && (target.isContentEditable || ['INPUT', 'TEXTAREA', 'SELECT'].includes(target.tagName));
    if (event.key === '/' && ! isTyping && ! event.metaKey && ! event.ctrlKey && ! event.altKey) {
        event.preventDefault();
        document.querySelector('input[name="q"]')?.focus();
    }
});

// Create Vue app when DOM is loaded (empty #app mount — chat is render()-only so we never compile Blade HTML as a template)
document.addEventListener('DOMContentLoaded', () => {
    try {
        const mountEl = document.getElementById('app');
        if (! mountEl) {
            console.error('App mount element not found');

            return;
        }

        const chatEnabled = document.documentElement.dataset.kbChat === '1';

        const app = createApp({
            render() {
                return chatEnabled ? h(ChatWidget) : null;
            },
        });

        app.mount('#app');
    } catch (error) {
        console.error('Failed to initialize Vue app:', error);
    }
});